import { cn } from '@/lib/utils';
import { monthWeeks, ymdOf } from './time';
import type { AppointmentListItem } from './api';

const WEEKDAYS = ['seg', 'ter', 'qua', 'qui', 'sex', 'sáb', 'dom'];

export function MonthView({ date, today, tz, events, onPickDay }: { date: string; today: string; tz: string; events: AppointmentListItem[]; onPickDay: (d: string) => void }) {
  const byDay = new Map<string, AppointmentListItem[]>();
  for (const e of events) {
    const k = ymdOf(e.startsAt, tz);
    byDay.set(k, [...(byDay.get(k) ?? []), e]);
  }
  const weeks = monthWeeks(date);
  const month = date.slice(0, 7);
  return (
    <div className="overflow-hidden rounded-lg border bg-card" role="grid" aria-label="Calendário do mês">
      <div className="grid grid-cols-7 border-b bg-muted/40 text-center text-xs text-muted-foreground" role="row">
        {WEEKDAYS.map((w) => (
          <div key={w} className="py-2" role="columnheader">
            {w}
          </div>
        ))}
      </div>
      {weeks.map((week, wi) => (
        <div key={wi} className="grid grid-cols-7 border-b last:border-b-0" role="row">
          {week.map((d) => {
            const list = byDay.get(d) ?? [];
            const outside = d.slice(0, 7) !== month;
            const colors = [...new Set(list.map((e) => e.barberColor))].slice(0, 5);
            return (
              <button
                key={d}
                type="button"
                role="gridcell"
                onClick={() => onPickDay(d)}
                aria-label={`${Number(d.slice(8))} de ${d.slice(5, 7)}: ${list.length} agendamento(s)`}
                className={cn(
                  'flex min-h-20 flex-col items-start gap-1 border-r p-2 text-left transition last:border-r-0 hover:bg-accent focus-visible:bg-accent focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-ring',
                  outside && 'bg-muted/30 text-muted-foreground',
                )}
              >
                <span className={cn('tabular inline-flex size-6 items-center justify-center rounded-full text-sm', d === today && 'bg-primary text-primary-foreground')}>{Number(d.slice(8))}</span>
                {list.length > 0 && (
                  <>
                    <span className="tabular text-xs font-medium">{list.length}<span className="hidden sm:inline"> {list.length === 1 ? 'horário' : 'horários'}</span></span>
                    <span className="flex gap-1" aria-hidden>
                      {colors.map((c) => (
                        <span key={c} className="h-1.5 w-4 rounded-full" style={{ background: c }} />
                      ))}
                    </span>
                  </>
                )}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
